import TextField from "@mui/material/TextField/TextField";
import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../../../providers/AuthProvider";
import { commonGet } from "../../../../services/reportService";
import { ReportProps } from "../../../../types/types";
import { Option } from "../../../manageReport/type";
import MenuItem from "@mui/material/MenuItem";

export function EntityReportFormPage(props: ReportProps) {
  const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);

  const [options, setOptions] = useState<Option[]>([]);

  const createOption = (label: string) => ({
    label,
    value: label.toLowerCase().replace(/\W/g, ""),
  });

  const fetchEntities = useCallback (async (): Promise<void> => {
    let url = "/v1/system/cdm/info?source=portal";
    let response = await commonGet(url, authContext);
    if (response) {
      //let obj = {};
      const optionValues: Option[] = response.features.map(function (
        value: any
      ) {
        if(value.name && value.calzz){
          let myObj: { [key: string]: string } = {};
          myObj.name = value.name;
          myObj.clazz = value.clazz;
          return createOption(value.name);
        }
      });
      setOptions(optionValues);
    }
  },[]);

  useEffect(() => {
    fetchEntities();
  }, [fetchEntities]);

  return (
    <div className="kpi-filter-wrapper full-width-height wizard-content-card ">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="full-width">
          <div className="input-div select">
            {/* Report Type Select */}

            <TextField
              id="entity_class"
              select
              label="Entty Class:"
              sx={{ m: 1, width: "75%" }}
              SelectProps={{
                readOnly:
                  props.reportInfo.viewEditStatus === "VIEW" ? true : false,
                native: false,
              }}
              placeholder="Select Class Name"
              helperText="Select desired Entity Class name eg: Orders If Data required from Orders"
            >
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </div>
        </div>
      </div>
    </div>
  );
}
